/**
 * EPC Contract Administration deep-link helpers.
 * Keep paths in sync with backend entity-action-url-registry.ts.
 */

export const EPC_CA_ENTITY_TYPES = [
  'epc_payment_application',
  'epc_variation',
  'epc_claim',
  'epc_eot',
  'epc_final_account',
  'epc_contract_closeout',
] as const;

export type EpcCaEntityType = (typeof EPC_CA_ENTITY_TYPES)[number];

/** Workspace Tabs `key` for each approval entity type. */
export const EPC_CA_TAB_BY_ENTITY: Record<EpcCaEntityType, string> = {
  epc_payment_application: 'progress',
  epc_variation: 'variations',
  epc_claim: 'claims',
  epc_eot: 'eot',
  epc_final_account: 'final-account',
  epc_contract_closeout: 'closeout',
};

export function isEpcCaEntityType(entityType: string): entityType is EpcCaEntityType {
  return (EPC_CA_ENTITY_TYPES as readonly string[]).includes(entityType);
}

/** Relative SPA path used by inbox Open document + BE getEntityActionUrl. */
export function epcCaDocumentBridgePath(entityType: string, entityId: string): string | null {
  if (!isEpcCaEntityType(entityType) || !entityId) return null;
  return `/epc/commercial/ca-doc/${entityType}/${encodeURIComponent(entityId)}`;
}

export function epcCaWorkspaceDeepLink(contractId: string, entityType: EpcCaEntityType, docId: string): string {
  const caTab = EPC_CA_TAB_BY_ENTITY[entityType];
  const q = new URLSearchParams({ caTab, docId });
  return `/epc/commercial/contracts/${encodeURIComponent(contractId)}?${q.toString()}`;
}
